<template lang='pug' src='./custom-home-why.pug'></template>

<script>
export default {
  props: ['props'],
  computed: {
    shape () {
      return require(`@/assets/icons/Group.svg`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-why.vue?5b3f1e5c